/**
 * Williams Fractals
 *
 * Bill Williams' fractal pattern indicator. A fractal high is a bar
 * with at least 2 lower highs on each side. A fractal low has 2
 * higher lows on each side. Plotted as arrows above/below price.
 *
 * Category: Support/Resistance | Pane: Overlay
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const fractalsIndicator: IndicatorDefinition = {
  id: "fractals",
  name: "Williams Fractals",
  shortName: "FRACT",
  category: "support_resistance",
  pane: "overlay",
  params: [
    { key: "lookback", label: "Lookback", type: "number", default: 2, min: 1, max: 10 },
  ],
  plots: [
    { key: "fractalHigh", label: "Fractal High", color: "#F44336", style: "circles", lineWidth: 3 },
    { key: "fractalLow", label: "Fractal Low", color: "#4CAF50", style: "circles", lineWidth: 3 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { lookback } = params;
    const highs: { time: number; value: number }[] = [];
    const lows: { time: number; value: number }[] = [];

    for (let i = lookback; i < candles.length - lookback; i++) {
      let isHigh = true;
      let isLow = true;

      for (let j = 1; j <= lookback; j++) {
        if (candles[i].high <= candles[i - j].high || candles[i].high <= candles[i + j].high) {
          isHigh = false;
        }
        if (candles[i].low >= candles[i - j].low || candles[i].low >= candles[i + j].low) {
          isLow = false;
        }
      }

      if (isHigh) highs.push({ time: candles[i].time, value: candles[i].high });
      if (isLow) lows.push({ time: candles[i].time, value: candles[i].low });
    }

    return [
      { key: "fractalHigh", data: highs },
      { key: "fractalLow", data: lows },
    ];
  },
};
